import Decimal from 'decimal.js';
import { ComponentProps } from 'react';
import { cn } from '@/lib/ui-kit/utils';

type QuickAddButtonsProps = {
  onAdd?: (val: number) => void;
  onMax?: () => void;
  showMax?: boolean;
  showSign?: boolean;
  prefix?: string;
  suffix?: string;
  addOptions?: number[];
  currentValue?: number;
  allowedMax?: number;
  allowedMin?: number;
} & ComponentProps<'div'>;

const chipClass =
  'flex cursor-pointer items-center justify-center rounded-[8px] bg-v2-btn-secondary-2 px-2 py-1 text-[12px] leading-[1.5] text-v2-text-primary opacity-50 transition-opacity hover:opacity-100 disabled:pointer-events-none disabled:opacity-30';

export function QuickAddButtons({
  addOptions = [],
  currentValue,
  prefix = '',
  suffix = '',
  showMax = false,
  showSign = false,
  allowedMax = Infinity,
  allowedMin = -Infinity,
  onAdd,
  onMax,
  className,
  ...props
}: QuickAddButtonsProps) {
  return (
    <div className={cn('flex items-center gap-1', className)} {...props}>
      {addOptions.map((value) => {
        const withAdded = Decimal(currentValue ?? 0).plus(value);
        const disabled =
          currentValue !== undefined &&
          (withAdded.greaterThan(allowedMax) || withAdded.lessThan(allowedMin));
        return (
          <button
            type="button"
            key={value}
            disabled={disabled}
            onClick={() => onAdd?.(value)}
            className={chipClass}
          >
            {showSign ? (value > 0 ? '+' : '') : ''}
            {prefix}
            {value}
            {suffix}
          </button>
        );
      })}
      {showMax ? (
        <button type="button" onClick={() => onMax?.()} className={chipClass}>
          +MAX
        </button>
      ) : null}
    </div>
  );
}
